<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>

<app-skelitions [hidden]="!skelition" [value]="5" class="mb-2"></app-skelitions>


<div class="container">
    <div class="table-container">
      <div class="d-flex justify-content-center">
        <input class="ppp-input ms-border" type="text" pInputText placeholder="Search" [(ngModel)]="searchText" (input)="filterData()">
      </div>
      <p-table [value]="filteredData">
          <!-- Table columns -->
          <ng-template pTemplate="header">
            <tr>
              <th>{{"name" | translator}}</th>
              <th>{{"Table" | translator}}</th>
              <th>{{"Graph Name" | translator}}</th>
              <th>{{"Graph Type" | translator}}</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.table }}</td>
              <td>{{ item.graphname }}</td>
              <td>{{ item.graphtype }}</td>
              <td>
                <p-button icon="pi pi-pencil" styleClass="p-button-rounded p-button-secondary m-2" (click)="editItem(item, rowIndex)"></p-button>
                <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger m-2"></p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>


      <app-edit [displayDialog]="displayDialog" [selectedItem]="selectedItem" (onSave)="saveEditedItem()" (onHide)="hideEditDialog()"></app-edit>


</div>
